import { GridColDef, GridValueGetterParams } from "@mui/x-data-grid";
import { createdAtmodifiedAtActions, formatDateAndTime } from "../../../../../helpers/appHelpers";

export const Columns: GridColDef[] = [
	{
		field: "name",
		headerName: "Currency",
		minWidth: 200,
		flex: 1,
		headerClassName: "super-app-theme--header",
	},
	{
		field: "code",
		headerName: "Currency Code",
		minWidth: 200,
		flex: 1,
		headerClassName: "super-app-theme--header",
	},
	{
		field: "symbol",
		headerName: "Symbol",
		minWidth: 180,
		flex: 1,
		headerClassName: "super-app-theme--header",
	},
	{
		field: "active",
		headerName: "Active",
		minWidth: 140,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value ? "Yes" : "No",
	},
	{
		field: "isDefault",
		headerName: "Default",
		minWidth: 140,
		flex: 1,
		headerClassName: "super-app-theme--header",
		valueGetter: (params) => params.value ? "Yes" : "No",
	},
	
	...createdAtmodifiedAtActions
];
